import React, { useContext, useEffect, useState } from 'react';
import PaymentFields from './paymentFields';
import {
  isValidationValidated,
  mapShipPayloadData,
  removeNullProperties,
} from '../../../utils/helper';
import { useShipForm } from '../../../context/shipForms';
import {
  BillingAddressDto,
  ContactDto,
  ReferenceRouteFormDto,
} from '../../../types';
import { addLegInShipment, makeShipment } from '../../../api/shipmentForms';
import { publiShipResponse } from '../../../dummy-data';
import { useLocation, useNavigate } from 'react-router-dom';
import TCModal from './tcModal';
import ShippingPaymentLoading from './shippingPaymentLoading';
import {
  billingAddressInitialValues,
  billingAddressValidationValues,
} from '../../../initial-values';
import { AbilityContext } from '../../../context/AbilityContext';
import { useSnackbar } from 'notistack';
interface Props {
  setShowSummary: any;
  setShowPayment: any;
  setCurrentShipmentStatus: any;
}
function PaymentForm({
  setShowPayment,
  setShowSummary,
  setCurrentShipmentStatus,
}: Props) {
  const navigate = useNavigate();
  const {
    getRatesApiPayloadContext,
    getRatesApiDataContext,
    getReferenceFormDataContext,
    getShipperFormData,
    getConsigneeFormData,
    getSpecialInstructionContext,
    getPickupPayloadContext,
    getSelectedRateContext,
    getShippingDocsContext,
    getSelectedServiceContext,
    getBrokerFormDataContext,
    getSelectedJobContext,
    getAddLegShipmentDataContext,
    getAllCommoditiesContext,
    getFinalRateContext
  } = useShipForm();
  const location = useLocation();
  const isAddLegs = location.pathname === '/app/add-leg';
  const quote_id = new URLSearchParams(location.search).get('quote_id');
  const ratesApiPayloadContext: any = getRatesApiPayloadContext();
  const ratesApiDataContext: any = getRatesApiDataContext();
  const referenceFormDataContext: ReferenceRouteFormDto =
    getReferenceFormDataContext();
  const ability = useContext(AbilityContext);
  const { enqueueSnackbar } = useSnackbar();
  const isAdmin = ability.can('read', 'Admin Shipments');
  const shipperFormData: ContactDto = getShipperFormData();
  const consigneeFormData: ContactDto = getConsigneeFormData();
  const specialInstructionContext: string = getSpecialInstructionContext();
  const pickupPayloadContext: any = getPickupPayloadContext();
  const selectedRateContext: any = getSelectedRateContext();
  const shippingDocsContext: any = getShippingDocsContext();
  const servicesDataContext: any = getSelectedServiceContext();
  const brokerFormDataContext = getBrokerFormDataContext();
  const selectedJobContext: any = getSelectedJobContext();
  const finalCostContext = getFinalRateContext();
  const addLegShipmentDataContext: any = getAddLegShipmentDataContext();
  const allCommoditiesContext: any = getAllCommoditiesContext();
  const [billingForm, setBillingForm] = useState<BillingAddressDto>(
    billingAddressInitialValues
  );
  const [billingFormValidations, setBillingFormValidations] = useState(
    billingAddressValidationValues
  );
  const [openTCModal, setOpenTCModal] = useState(false);
  const [isBillingAddressSame, setIsBillingAddressSame] = useState(true);
  const [loading, setLoading] = useState(false);
  const [validating, setValidating] = useState(false);
  const [shippingError, setShippingError] = useState('');
  const [isPayment, setIsPayment] = useState(ability.can('create', 'Payment'));
  function backRoute() {
    setShowPayment(false);
    setShowSummary(true);
    setCurrentShipmentStatus('summary');
  }
  const doMonerisSubmit = () => {
    const monFrameRef = document.getElementById(
      'monerisFrame'
    ) as HTMLIFrameElement;
    window.addEventListener('message', handleMonerisResponse);
    monFrameRef.contentWindow?.postMessage(
      'tokenize',
      `${process.env.REACT_APP_UBBE_MONERIS_HPP_TOKEN_URL}`
    );
  };
  const handleMonerisResponse = (e: MessageEvent) => {
    setLoading(true);
    if (e.origin === `${process.env.REACT_APP_UBBE_MONERIS_API_URL}`) {
      const respData = JSON.parse(e.data);
      if (respData.dataKey) {
        // setLoading(false);
        shipAndPay(respData.dataKey);
      } else {
        // setLoading(false);
      }
      document.getElementById(
        'monerisResponse'
      )!.innerHTML = `${respData.responseCode}`;
      window.removeEventListener('message', handleMonerisResponse);
    }
  };
  function shipAndPay(monerisToken: string | undefined) {
    let payload = mapShipPayloadData(
      ratesApiPayloadContext,
      ratesApiDataContext,
      referenceFormDataContext,
      shipperFormData,
      consigneeFormData,
      specialInstructionContext,
      monerisToken,
      pickupPayloadContext,
      selectedRateContext,
      isBillingAddressSame,
      billingForm,
      shippingDocsContext,
      servicesDataContext,
      undefined,
      undefined,
      undefined,
      brokerFormDataContext,
      quote_id,
      selectedJobContext,
      addLegShipmentDataContext?.shipment_id,
      allCommoditiesContext,
      finalCostContext
    );
    payload = removeNullProperties(payload);

    if (isAddLegs) {
      let newPayload: any = payload;
      newPayload.shipment_legs = payload.service;
      delete newPayload?.packages;
      delete newPayload?.booking_date;
      delete newPayload?.service;
      delete newPayload?.origin;
      delete newPayload?.destination;
      delete newPayload?.pickup;
      delete newPayload?.is_pickup;

      delete newPayload?.account_number;
      delete newPayload?.freight;
      delete newPayload?.surcharge;
      delete newPayload?.tax;
      delete newPayload?.cost;
      delete newPayload?.billing;
      delete newPayload?.special_instructions;
      delete newPayload?.is_declared_dangerous_goods;
      newPayload.documents = payload?.documents ? payload?.documents : [];
      addLegInShipment(newPayload)
        .then((response) => {
          if (response?.data?.is_error === false) {
            navigate(
              `/app/ship-now/confirmation?shipment_id=${response?.data?.content?.shipment_id}`,
              {
                state: { additionalData: response?.data?.content },
              }
            );
          }
        })
        .catch((e) => {
          setShippingError(JSON.stringify(e?.response?.data?.error));
        });
    } else {
      let shipPayload: any = payload;
      shipPayload.shipment = payload?.service;
      delete shipPayload.service;
      if(!shipPayload?.moneris_token) {
        delete shipPayload?.billing;
      }
      makeShipment(payload)
        .then((response) => {
          if (response?.data?.is_error === false) {
            navigate(
              `/app/ship-now/confirmation?shipment_id=${response?.data?.content?.shipment_id}`,
              {
                state: { additionalData: response?.data?.content },
              }
            );
          }
        })
        .catch((e) => {
          setShippingError(JSON.stringify(e?.response?.data?.error));
        });
    }
  }
  function handlePayAndShip() {
    if (isBillingAddressSame) {
      setOpenTCModal(true);
    } else {
      setValidating(true);
      if (isValidationValidated(billingFormValidations)) {
        setValidating(false);
        setOpenTCModal(true);
      }
    }
  }
  useEffect(() => {
    if (!isPayment) {
      setLoading(true);
      shipAndPay(undefined);
    }
  }, [isPayment]);
  return (
    <div id='payment_section'>
      {!loading ? (
        <>
          <PaymentFields
            isBillingAddressSame={isBillingAddressSame}
            setIsBillingAddressSame={setIsBillingAddressSame}
            validating={validating}
            billingForm={billingForm}
            setBillingForm={setBillingForm}
            billingFormValidations={billingFormValidations}
            setBillingFormValidations={setBillingFormValidations}
          />
          <div className='row mt-5'>
            <div className='col-4 col-lg-2'>
              <p
                className='btn btn-ubbe-new-back d-flex gap-2'
                onClick={() => {
                  backRoute();
                }}
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='15'
                  height='8'
                  viewBox='0 0 15 8'
                  fill='none'
                >
                  <path
                    d='M3.03077 0.670207L0.176923 3.5735C0.123077 3.62828 0.0769229 3.69871 0.0461536 3.77697C0.0461536 3.7848 0.0461536 3.79262 0.0384613 3.80045C0.0153844 3.86305 -1.56239e-07 3.92566 -1.53161e-07 3.99609C-1.4632e-07 4.1526 0.0615383 4.30129 0.169231 4.41084L3.03077 7.32979C3.25385 7.55674 3.62308 7.55674 3.84615 7.32979C4.06923 7.10285 4.06923 6.72722 3.84615 6.50028L1.96154 4.58301L14.4231 4.58301C14.7385 4.58301 15 4.31694 15 3.99609C15 3.67524 14.7385 3.40917 14.4231 3.40917L1.96923 3.40917L3.84615 1.49972C3.96154 1.38234 4.01538 1.23365 4.01538 1.08496C4.01538 0.936277 3.96154 0.787591 3.84615 0.670207C3.62308 0.443265 3.26154 0.443265 3.03077 0.670207Z'
                    fill='black'
                  />
                </svg>
                Back
              </p>
            </div>
            <div className='col-4 col-lg-8'></div>
            <div className='col-4 col-lg-2 text-end'>
              {isPayment && (
                <p
                  className='btn-ubbe-new-blue  justify-content-center '
                  onClick={() => {
                    // doMonerisSubmit();
                    // setOpenTCModal(true);
                    handlePayAndShip();
                  }}
                >
                  Pay & Ship
                </p>
              )}
            </div>
          </div>
          {openTCModal && (
            <TCModal
              setOpenTCModal={setOpenTCModal}
              doMonerisSubmit={doMonerisSubmit}
            />
          )}
        </>
      ) : (
        <ShippingPaymentLoading
          shippingError={shippingError}
          setCurrentShipmentStatus={setCurrentShipmentStatus}
          setShowPayment={setShowPayment}
          setShowSummary={setShowSummary}
        />
      )}
    </div>
  );
}

export default PaymentForm;
